import React, { Component } from 'react'
import IconRow from './IconRow'

import aboutConfig from '../../configs/about-config';

class AboutBody extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <IconRow config={aboutConfig}/>
      </div>
    )
  }
}

export default AboutBody



// WEBPACK FOOTER //
// ./src/components/Home/AboutBody.js